import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBR48Mxl-ZGGgyxlgRS7xBSS0_lhvg_968",
  authDomain: "disney-hotstar-clone-9d3fc.firebaseapp.com",
  projectId: "disney-hotstar-clone-9d3fc",
  storageBucket: "disney-hotstar-clone-9d3fc.appspot.com",
  messagingSenderId: "66787901517",
  appId: "1:66787901517:web:45221d3c5ad1066ff91c04",
  measurementId: "G-TSMGFNEXTG",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();
const storage = firebase.storage();

export { auth, provider, storage };
export default db;
